import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError, switchMap } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { isPublicAuthPath } from './token.interceptor';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Los endpoints públicos de auth (login, refresh, version) no deben
        // disparar un intento de refresh: un 401 ahí es un login fallido o
        // un refresh ya fallido, no una sesión expirada.
        if (isPublicAuthPath(req.url)) {
          return throwError(() => error);
        }
        if (error.status !== 401) {
          return throwError(() => error);
        }
        const mensaje = error?.error?.message?.toLowerCase() || '';
        if (mensaje.includes('no tiene permisos') || mensaje.includes('sin permisos') || mensaje.includes('forbidden')) {
          return throwError(() => error);
        }
        return this.authService.refreshToken().pipe(
          switchMap(() => {
            const token = this.authService.getToken();
            const authReq = req.clone({
              setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
            });
            return next.handle(authReq);
          }),
          catchError(() => {
            this.authService.logout();
            return throwError(() => error);
          }),
        );
      }),
    );
  }
}
